module.exports = __webpack_public_path__ + "img/mobile.00686b02.png";